import { colors } from '@ardoq/design-tokens';

type DrawImageToCanvasArgs = {
  img: HTMLImageElement;
  canvas: HTMLCanvasElement;
  width: number;
  height: number;
  padding: number;
};

const drawImageToCanvas = ({
  img,
  canvas,
  width,
  height,
  padding,
}: DrawImageToCanvasArgs) => {
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }
  // #region white background rectangle
  ctx.fillStyle = colors.white950;
  ctx.fillRect(0, 0, width, height);
  // #endregion

  const { naturalWidth, naturalHeight } = img;

  const isTall = height > width;
  const aspectRatio = width / height;

  const destinationWidth =
    (isTall ? width : height * aspectRatio) - 2 * padding;
  const destinationHeight =
    (isTall ? width / aspectRatio : height) - 2 * padding;
  const destinationX = Math.max(0, (width - destinationWidth) / 2) + padding;
  const destinationY = Math.max(0, (height - destinationHeight) / 2) + padding;
  ctx.drawImage(
    img,
    0,
    0,
    naturalWidth,
    naturalHeight,
    destinationX,
    destinationY,
    destinationWidth,
    destinationHeight
  );
};

export { drawImageToCanvas };
